export default {
  STANDARD_PAY: 'standardpay',
  WASTE_PAY: 'wastepay'
}
